import "./App.css";
import MainRoute from "./route/route";

function App() {
  return (
    <div>
      <MainRoute />
    </div>
  );
}

export default App;
